import { getAccessToken } from './auth.js';
import { parse, serialize } from 'tinyduration';
import { isAuthenticated } from './stores.js';

export function getNumberOfAvailablePreviewsForSlice(previews, sliceIndex, type) {
    let availablePreviews;
    switch (type) {
        case 'CENTERSHIFT': 
            availablePreviews = previews;
            console.log(`CENTERSHIFT SLICES PREVIEWS FOR ${sliceIndex} SEEN: `, previews);
            break;
        case 'BEAMHARD_CUPPING': 
            availablePreviews = previews;
            console.log(`BEAMHARD_CUPPING PREVIEWS FOR ${sliceIndex} SEEN: `, previews);
            break;
        case 'PHASE_RETRIEVAL':
            availablePreviews = previews;
            console.log(`PHASE_RETRIEVAL PREVIEWS FOR ${sliceIndex} SEEN: `, previews);
            break;
        case 'FINAL': 
            availablePreviews = previews;
            console.log(`FINAL PREVIEWS FOR ${sliceIndex} SEEN: `, previews);
            break;
        default:
            break;
    }

    console.log(`NUM OF AVAIABLE ${type} PREVIEWS FOR SLICE ${sliceIndex} IS: `, availablePreviews?.length || 0);
    return availablePreviews?.length || 0;
}

export function formatJson(json) {
    let str = JSON.stringify(json, null, 2);
    return str;
}

function findNullEntries(obj, path = '') {
    const nullEntries = [];

    for (const [key, value] of Object.entries(obj)) {
        const currentPath = path ? `${path}.${key}` : key;

        if (value === null) {
            nullEntries.push(currentPath);
        } else if (typeof value === 'object' && value !== null) {
            nullEntries.push(...findNullEntries(value, currentPath));
        }
    }

    return nullEntries;
}

// Check for null entries. Return object with message if found, otherwise undefined
export function checkForErrorsInJson(json) {
    let nullValues = findNullEntries(json);

    if (nullValues?.length > 0) {
        return {msg: 'Invalid value found in input. Please check your form settings.'};
    }
    return undefined;
}

export function timeComparator(a, b) {
    if ( b.startTime > a.startTime ) return 1;
    else if ( a.startTime > b.startTime ) return -1;
    else return 0;
}

export function extractLatestPhaseRetrievalBaseAndTime(preview) {
    const sortedDatasets = [...preview.preview_output];
    sortedDatasets?.sort(timeComparator);
    const latestDataset = sortedDatasets[0];

    let pattern = /.*\/(.*-ph\d+)-.*/;
    let phaseRetrieval = latestDataset?.large_image_pattern?.match(pattern);
    let startTime = latestDataset?.start_time;
    let delta = preview.preview_input.generic_preview_input.phase_retrieval_settings.phase_retrieval.delta;
    let mu = preview.preview_input.generic_preview_input.phase_retrieval_settings.phase_retrieval.mu;
    if (phaseRetrieval?.length > 0) {
        return {
            base: phaseRetrieval[1],
            startTime: startTime,
            delta: delta,
            mu: mu
        };
    }
}

export function phaseRetrievalComparator(a, b) {
    if ( b.delta / b.mu > a.delta / a.mu ) return -1;
    else if ( a.delta / a.mu > b.delta / b.mu ) return 1;
    else return 0;
}

export function extractPhaseRetrievalBaseFromPath(datasetPath) {
    let pattern = /.*\/(.*-ph\d+)-.*/;
    let phaseRetrieval = datasetPath?.match(pattern);
    if (phaseRetrieval?.length > 0) {
        return phaseRetrieval[1];
    }
}

export function extractPreprocessingBaseFromPath(datasetPath) {
    let pattern = /\/*(.*-pre\d+)-.*/;
    let preprocessing = datasetPath?.match(pattern);
    if (preprocessing?.length > 0) {
        return preprocessing[1];
    }
}

export function extractDatasetName(preview, sliceIndex) {
    let datasetName;
    if (!isNumeric(sliceIndex)) {
        datasetName = extractDatasetNameFromPath(preview?.preview_output?.[0]?.large_image_pattern);
    } else {
        datasetName = extractDatasetNameFromPath(preview?.preview_output?.find(s => s.slice === sliceIndex)?.large_image_pattern);
    }
    return datasetName;
}

export function extractDatasetNameFromPath(path) {
    const regexp = /\d+-tomo-pre\d+-ph\d+\d+-rec\d+/;
    const match = regexp.exec(path);
    return match;
}

export function extractTomographyDatasetNameFromPath(path) {
    const regexp = /(\d+-tomo).*/;
    const match = regexp.exec(path);
    return match?.[1];
}

export function extractSliceName(previewPath) {
    return extractSliceNameFromPath(previewPath);
}

function extractSliceNameFromPath(path) {
    // Match both old style .../slice_0_%04d.tif/...
    // and new style .../reconstruction_0_binning_1_slice_%04d.tif
    const regexp = /^.+\/(.*slice_(?:\d+_)?).+$/;
    const match = regexp.exec(path);
    return match;
}

export function extractSessionName(preview, sliceIndex) {
    let sessionName;
    if (!isNumeric(sliceIndex)) {
        sessionName = extractSessionNameFromPath(preview?.preview_output?.[0]?.large_image_pattern);
    } else {
        sessionName = extractSessionNameFromPath(preview?.preview_output?.find(s => s.slice === sliceIndex)?.large_image_pattern);
    }
    return sessionName;
}

function extractSessionNameFromPath(path) {
    const regexp = /ses-[^/]*/;
    const match = regexp.exec(path);
    return match;
}



export function now() {
    const d = new Date();
    const now = d.toISOString();
    return now;
}

export function isoDateToDate(isoDateTimeString) {
    return isoDateTimeString ? isoDateTimeString.substr(0, 10) : '';
}

export function isoDateToTime(isoDateTimeString) {
    return isoDateTimeString ? isoDateTimeString.substr(11, 8) : '';
}

export function millisecondsToDate(milliseconds) {
    if (!milliseconds) return;
    const d = new Date(milliseconds);
    const isoDateTimeString = d.toISOString();
    return isoDateToDate(isoDateTimeString);
}

export function millisecondsToTime(milliseconds) {
    if (!milliseconds) return;
    const d = new Date(milliseconds);
    const isoDateTimeString = d.toISOString();
    return isoDateToTime(isoDateTimeString);
}

export function durationInMilliseconds(startMilliseconds, endMilliseconds) {
    if (!isNumeric(startMilliseconds) || !isNumeric(endMilliseconds) ) return;
    return endMilliseconds - startMilliseconds;
}

export function isoDurationOrSecondsToBestTimeUnits(durationString) {
    if (isNumeric(durationString)) {
        return millisecondsToBestTimeUnits(durationString * 1000);
    }

    try {
        const d = parse(durationString);
        const seconds = (d?.years || 0) * 3600 * 24 * 365 + (d?.months || 0) * 3600 * 24 * 30 + (d?.weeks || 0) * 3600 * 24 * 7 + (d?.days || 0) * 3600 * 24 + (d?.hours || 0) * 3600 + (d?.minutes || 0) * 60 + (d?.seconds || 0);
        return millisecondsToBestTimeUnits(seconds * 1000);
    } catch (err) {
        return undefined;
    }
}

// Best string to show depending on the time. E.g:
// 7202000 ms = 120.033333333333 mins = 2.00055555566 h => 2 h 00 min 2 s
export function millisecondsToBestTimeUnits(milliseconds) {
    if (!isNumeric(milliseconds) || milliseconds < 0 ) return;
    const s = Math.floor(milliseconds / 1000); // 7202
    const m = Math.floor(s / 60); // 120
    const h = Math.floor(s / 3600); // 2

    // Calculate remainders after larger unit taken off
    const H = (h > 0) ? h : 0; // 2
    const M = (m - h * 60 > 0) ? m - h * 60 : 0; // 0

    let str = '';
    if (H > 0) str = `${H} h`; // 2
    if (M > 0) str += ` ${M} min`; // 0
    if (s - H * 3600 - M * 60 > 0) str += ` ${s - H * 3600 - M * 60} s`; // 7202-2*3600+0*60=2
    return str;
}

export function isNumeric(num) {
    return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);
}

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export function getScanThumbnailUrl(scanDetail) {
    // Extract the url to the thumbnail
    // In EXC-788 the API has changed from using a pattern to a single straight URL with pr0000.
    let url = scanDetail?.thumbnail_image || scanDetail?.thumbnail_image_pattern;

    if (!url) return '#';

    if (scanDetail?.thumbnail_image_pattern) {
        const index = 0; // TODO: When we have multiple projection images to choose from, this will have to be changed
        const indexString = String(index).padStart(4, '0');
        url = url.replace('pre%04d', `pre${indexString}`);
        url = url.replace('pr%04d', `pre${indexString}`); // NOTE: The API has a bug, giving name as pr instead of pre. Remove this line when fixed
    }

    return url;
}

// Display names for camera strings, e.g. camera-photonicscience-gsense4040xl-201089 -> GSense
export function getLegacyCameraDisplayNameFromString(cameraString) {
    switch (cameraString) {
        case 'camera-photonicscience-gsense4040xl-201089': return 'GSense XL';
        case 'camera-photonicscience-gsense4040xl-221094': return 'GSense XL';
        case 'camera-rigaku-xsight-002-069-1080-038': return 'Rigaku';
        case 'camera-rigaku-xsight-002-069-0540-012': return 'Rigaku';
        case 'camera-exciscope-exciview-0001-10x': return 'Exciview 10x';
        case 'camera-exciscope-exciview-0002-10x': return 'Exciview 10x';
        case 'camera-exciscope-exciview-0003-10x': return 'Exciview 10x';
        case 'camera-exciscope-exciview-0002-4x': return 'Exciview 4x';
        case 'camera-exciscope-exciview-0003-4x': return 'Exciview 4x';
        case 'camera-exciscope-exciview-0002-2x': return 'Exciview 2x';
        case 'camera-exciscope-exciview-0003-2x': return 'Exciview 2x';
        case 'camera-testcompany-testmodel-sn': return 'Testmodel';
        default: return cameraString;
    }
}

export function getCameraDisplayNameFromString(cameraString) {
    if (cameraString?.includes('photonicscience-gsense4040xl')) return 'GSense XL';
    if (cameraString?.includes('rigaku-xsight')) return 'Rigaku';
    if (cameraString?.includes('exciscope-exciview')) {
        if (cameraString.includes('10x')) return 'Exciview 10x';
        if (cameraString.includes('4x')) return 'Exciview 4x';
        if (cameraString.includes('2x')) return 'Exciview 2x';
    }
    return cameraString;
}

function getCameraStringFromCalibrationId(calibrationId) {
    let pattern = /\/calibrations\/(\S+)\s.*/;
    let match = calibrationId?.match(pattern);
    if (match?.length >= 1) {
        return match[1];
    }
}

export function getCameraDisplayNameFromCalibrationId(calibrationId) {
    const camStr = getCameraStringFromCalibrationId(calibrationId);
    return getCameraDisplayNameFromString(camStr);
}

// Show a user-friendlier name for some stacks
export function getStackDisplayName(stackname) {
    switch (stackname) {
        case "ExtprodBohr":
            return "Uni Basel";
        case "ExtprodMeitner":
            return "KTH/KI";
        case "ExtprodDTU":
            return "DTU";
        case "CloudCTIaaS":
            return "Intprod IaaS";
        case "CloudCTTest":
            return "Intprod Test";
        case "localdev":
        case "":
            return "localdev";
        default:
            return stackname;
    }
}

// Show a user-friendlier name for some organisations
export function getOrganisationDisplayName(orgname) {
    switch (orgname) {
        case "unibas":
            return "Uni Basel";
        case "karolinska":
        case "Karolinska":
        case "kth/ki":
        case "KTH/KI":
            return "KTH/KI";
        case "exciscope":
            return "Exciscope";
        case "dtu":
            return "DTU";
        case "test":
            return "Test";
        default:
            return orgname;
    }
}

/**
 * API call to get details for a specific tomography
 * @param session e.g. ses-220804-142015-blueberry
 * @param tomography e.g. 02-tomo
 * @return A JSON with the details for this tomography. Typically contains dataset_id, command, scan_information, result, default_parameters.
 */
export async function getTomographyDetailsApi(hostname, isAuthenticated, stack, session, tomography) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/get_tomography_details?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET TOMOGRAPHY DETAILS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET TOMOGRAPHY DETAILS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to get details for a specific reconstruction
 * @param session e.g. ses-220804-142015-blueberry
 * @param reconstruction e.g. 02-tomo-pre00-ph01-rec04
 * @return A JSON with the details for this reconstruction. Typically contains dataset_id, large_image_pattern, min_slice, max_slice.
 */
export async function getReconstructionDetailsApi(hostname, isAuthenticated, stack, session, reconstruction) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/get_reconstruction_details?session=${session}&reconstruction=${reconstruction}`;
            if (stack) url += `&stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET RECONSTRUCTION DETAILS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET RECONSTRUCTION DETAILS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to get details for a specific preview
 * @param session e.g. ses-220804-142015-blueberry
 * @param tomography e.g. 02-tomo
 * @returns A JSON with an array of previews, each speciying previewInput and previewOutput
 */
export async function getPreviewDetailsApi(hostname, isAuthenticated, stack, session, tomography) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            console.log(`Fetching ${session}/${tomography}`);
            let url = `${hostname}/api/get_previews?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET PREVIEW DETAILS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET PREVIEW DETAILS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to get details for a specific preview
 * @param session e.g. ses-220804-142015-blueberry
 * @param tomography e.g. 02-tomo
 * @returns A JSON with an array of previews grouped by its parameters, each speciying 
 * previewInput and previewOutput and typicallly a list of slices (not just one)
 */
export async function getGroupedPreviewDetailsApi(hostname, isAuthenticated, stack, session, tomography) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            console.log(`Fetching ${session}/${tomography}`);
            let url = `${hostname}/api/get_grouped_previews?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET PREVIEW DETAILS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET PREVIEW DETAILS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

export async function getSessionDetailsApi(hostname, isAuthenticated, stack, session) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/get_session_details?session=${session}`;
            if (stack) url += `&stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET SESSION DETAILS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET SESSION DETAILS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }  
    } else {
        return 401;
    }
}

/**
 * API call to start a new preview
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack, e.g. CloudCTTest
 * @param session e.g. ses-220804-142015-blueberry
 * @param tomography e.g. 02-tomo
 * @param previewSettings e.g. {generic_preview_input: ..., centershift_optimization: ..., previews: ...}
 * @returns Response from datapipeline
 */
export async function runPreviewApi(hostname, isAuthenticated, stack, session, tomography, previewSettings) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            console.log(`Fetching ${session}/${tomography}`);
            let url = `${hostname}/api/run_preview?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            let body = JSON.stringify(previewSettings);
            console.log('runPreviewApi BODY: ', body);
            const response = await fetch(url, 
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'content/type',
                        'Authorization': 'Bearer ' + token,
                        'x-custom-authorization': 'Bearer ' + token
                    },
                    body: body
                }
            );
            if (response.ok) {
                console.log('RUN PREVIEW API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('RUN PREVIEW API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * Old API call to start a new FDK reconstruction 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param {*} session e.g. ses-220804-142015-blueberry
 * @param {*} tomography e.g. 02-tomo
 * @param {*} fdkSettings e.g. {phase_retrieval_dataset_id: ..., command: {commands: []}, min_slice: ...}
 * @returns data if successful, error code otherwise
 */
export async function runReconstructionApi(hostname, isAuthenticated, stack, session, tomography, fdkSettings) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            console.log(`Fetching ${session}/${tomography}`);
            let url = `${hostname}/api/run_reconstruction?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            let body = JSON.stringify(fdkSettings);
            console.log('runReconstructionApi BODY: ', body);
            const response = await fetch(url, 
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'content/type',
                        'Authorization': 'Bearer ' + token,
                        'x-custom-authorization': 'Bearer ' + token
                    },
                    body: body
                }
            );
            if (response.ok) {
                console.log('RUN RECONSTRUCTION API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('RUN RECONSTRUCTION API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * New API call to start a new FDK reconstruction (/sessions/{session_id}/{tomography_dataset_id}/reconstruction)
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param {*} session e.g. ses-220804-142015-blueberry
 * @param {*} tomography e.g. 02-tomo
 * @param {*} fdkSettings e.g. {phase_retrieval_dataset_id: ..., command: {commands: []}, min_slice: ...}
 * @returns data if successful, error code otherwise
 */
export async function runReconstructionDagApi(hostname, isAuthenticated, stack, session, tomography, fdkSettings) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            console.log(`Fetching ${session}/${tomography}`);
            let url = `${hostname}/api/run_dag_reconstruction?session=${session}&tomography=${tomography}`;
            if (stack) url += `&stack=${stack}`;
            let body = JSON.stringify(fdkSettings);
            console.log('runDagReconstructionApi BODY: ', body);
            const response = await fetch(url, 
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'content/type',
                        'Authorization': 'Bearer ' + token,
                        'x-custom-authorization': 'Bearer ' + token
                    },
                    body: body
                }
            );
            if (response.ok) {
                console.log('RUN DAG RECONSTRUCTION API SUCCESS RESPONSE: ', response.status);
                if (response.status !== 200 && response.status !== 202) {
                    return response.status;
                }
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('RUN DAG RECONSTRUCTION API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}


/**
 * API call to fetch list of sessions known to this stack 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param filter an object with possible keys selection="TEAM" | "MINE", teamIds= list of teamIds, userIds=list of userIds
 * @return list of session objects if successful, HTTP error code otherwise
 */
export async function listSessionsApi(hostname, isAuthenticated, stack, filter, skip, limit) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/list_sessions`;
            if (stack) url += `?stack=${stack}`;
            if (filter.teamIds.length > 0) {url += `&teams=${filter.teamIds}`}
            if (filter.userIds.length > 0) {url += `&users=${filter.userIds}`}
            if (isNumeric(skip)) url += `&skip=${skip}`;
            if (isNumeric(limit)) url += `&limit=${limit}`;
            if (filter.sortOrder !== "") url += `&sort=${filter.sortOrder}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('LIST SESSIONS API RESPONSE: ', response.status);
                if (response.status !== 200) {
                    return response.status;
                }
                let data = await response.json();
                console.log(data);
                if (data) {
                    //return data.reverse();
                    // For now we assume that the sessions are listed in REVERSE chronological order already
                    return data;
                }
            } else {
                console.log('LIST SESSIONS API RESPONSE: ', response.status);
                return response.status;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to fetch list of pipelines known to this stack 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param {*} session e.g. ses-220804-142015-blueberry
 */
export async function listPipelinesApi(hostname, isAuthenticated, stack, session) {
    if (isAuthenticated) {
        let url = `${hostname}/api/list_pipelines?session=${session}`;
        if (stack) url += `&stack=${stack}`;
        const response = await fetch(url);
        let data = await response.json();
        console.log(data);
        if (data) {
            return data;
        }
    }
}

/**
 * API call to fetch list of ongoing pipelines known to this stack 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param {*} sessions list of session names, e.g. ['ses-220804-142015-blueberry', ...]
 * @return list of pipelines objects if successful, HTTP error code otherwise
 */
export async function listOngoingPipelinesApi(hostname, isAuthenticated, stack, sessions) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/list_ongoing_pipelines`;
            let stackname;
            if (stack) {
                url += `?stack=${stack}`;
                stackname = stack;
            }
            let options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    sessions: `${sessions}`,
                    stack: stackname
                })
            };

            const response = await fetch(url, options);
            if (response.status !== 200) {
                return response.status;
            }
            let data = await response.json();
            console.log(data);
            if (data) {
                return data;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to fetch list of all ongoing pipelines 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param filter an object with possible keys selection="TEAM" | "MINE", teamIds= list of teamIds, userIds=list of userIds
 * @param {*} age don't include older than this age
 * @return list of pipelines objects if successful, HTTP error code otherwise
 */
export async function listAllOngoingPipelinesApi(hostname, isAuthenticated, stack, filter, age) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/list_all_ongoing_pipelines`;
            if (stack) {
                url += `?stack=${stack}`;
            }
            if (filter?.teamIds?.length > 0) {url += `&teams=${filter?.teamIds}`}
            if (filter?.userIds?.length > 0) url += `&users=${filter?.userIds}`;
            if (age) {
                url += `&age=${age}`;
            }
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            };

            const response = await fetch(url, options);
            if (response.status !== 200) {
                return response.status;
            }
            let data = await response.json();
            console.log(data);
            if (data) {
                return data;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to fetch list of pipelines statuses known to this stack 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param {*} sessions list of fully qualified pipeline names, e.g. ['/sessions/ses-220804-142015-blueberry/pipelines/01', ...]
 * @return list of {pipeline, status} objects if found, or {pipeline, error} for not found, HTTP error code otherwise
 */
export async function listPipelinesStatusApi(hostname, isAuthenticated, stack, pipelines) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/list_pipelines_status`;
            let stackname;
            if (stack) {
                url += `?stack=${stack}`;
                stackname = stack;
            }
            let options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    pipelines: `${pipelines}`,
                    stack: stackname
                })
            };

            const response = await fetch(url, options);
            if (response.status !== 200) {
                return response.status;
            }
            let data = await response.json();
            console.log(data);
            if (data) {
                return data;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to start a machine in this stack 
 * @param hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param isAuthenticated e.g. true
 * @param stack datapipeline stack e.g. CloudCTTest
 * @param jobType PREPROCESSING, PHASE_RETRIEVAL or RECONSTRUCTION
 * @param size SMALL or BIG 
 * @return list of pipelines objects if successful, HTTP error code otherwise
 */
export async function startMachineApi(hostname, isAuthenticated, stack, jobType, size) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/start_machine`;
            if (stack) {
                url += `?stack=${stack}`;
            }
            let options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    jobType:  `${jobType || "RECONSTRUCTION"}`,
                    size: `${size || "SMALL"}`
                })
            };

            const response = await fetch(url, options);
            if (response.status !== 200) {
                return response.status;
            }
            let data = await response.json();
            console.log(data);
            if (data) {
                return data;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * 
 * @param {*} hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @returns a response containing details about the token verification
 */
export async function testAuth0Api(hostname) {
    try {
        const token = await getAccessToken();
        let url = `${hostname}/api/testauth0api`;
        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'content/type',
                'Authorization': 'Bearer ' + token,
                'x-custom-authorization': 'Bearer ' + token
            },
            body: JSON.stringify({token: token})
        };

        const response = await fetch(url, options);
        let data = await response.json();
        console.log(data);
        if (data) {
            return data;
        }
    } catch(err) {
        console.error("[Fetch Error]:", err);
        return 504;
    }
}

/**
 * 
 * @param {*} hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @returns a response containing details about the token verification
 */
export async function getAccessInfoApi(hostname) {
    try {
        const token = await getAccessToken();
        let url = `${hostname}/api/get_access_info`;
        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'content/type',
                'Authorization': 'Bearer ' + token,
                'x-custom-authorization': 'Bearer ' + token
            },
            body: JSON.stringify({token: token})
        };

        const response = await fetch(url, options);
        let data = await response.json();
        console.log(data);
        if (data) {
            return data;
        }
    } catch(err) {
        console.error("[Fetch Error]:", err);
        return 504;
    }
}

/**
 *
 * @param {string} hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param {string} organizationId organization id for teams you want to fetch
 * @returns a response of teams info of chosen information
 */
export async function getTeamsInfo(hostname,organizationId) {
    try{
        const token = await getAccessToken();
        const url = `${hostname}/api/get_teams_info?organizationId=${organizationId}`;
        const options = {
            method: "GET",
            headers: {
                'Content-Type': 'content/type',
                'Authorization': 'Bearer ' + token,
                'x-custom-authorization': 'Bearer ' + token
            },
        };
        const response = await fetch(url, options);
        const data = await response.json();
        if ( response.status !== 200) {
            return response.status;
        }
        if (data) {
            return data;
        }
    }
    catch(err) {
        console.log(err);
    }
}

/**
 *
 * @param {string} hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param {string} stack web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param {string} sessionId Session ID that contains the dataset id.
 * @param {string} datasetId string of data set id e.g 02_tomo....
 * @returns containing the result of the request.
 */
export async function deleteDataset(hostname, stack, sessionId, datasetId) {
    try{
        const token = await getAccessToken();
        const url = `${hostname}/api/delete_dataset?sessionId=${sessionId}&datasetId=${datasetId}&stack=${stack}`;
        const options = {
            method: "DELETE",
            headers: {
                'Content-Type': 'content/type',
                'Authorization': 'Bearer ' + token,
                'x-custom-authorization': 'Bearer ' + token
            },
        };
        const response = await fetch(url, options);
        const data = await response.json();
        if ( response.status !== 200) {
            return response.status;
        }
        if (data) {
            return data;
        }
    }
    catch(err) {
        console.log(err);
    }
}

/**
 *
 * @param {string} hostname web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param {string} stack web backend 'proxy' to call, e.g. https://zealous-smoke-0ff875103.azurestaticapps.net
 * @param {string} sessionId Session ID that contains the dataset id.
 * @returns containing the result of the request. Normally whatever comes from the coordinator backend
 */
export async function deleteSession(hostname, stack, sessionId) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            const url = `${hostname}/api/delete_session?sessionId=${sessionId}&stack=${stack}`;
            const options = {
                method: "DELETE",
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                },
            }
            const response = await fetch(url, options);
            if ( response.status !== 200) {
                return response.status;
            }
            if (response.ok) {
                console.log('GET DELETE SESSION API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET DELETE SESSION API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch(err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to get storage quotas info
 * @return A JSON with the stack's current storage usage and the allowed quota
 */
export async function getStorageQuotasApi(hostname, isAuthenticated, stack) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/get_quotas`;
            if (stack) url += `?stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET STORAGE QUOTAS API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET STORAGE QUOTAS API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}

/**
 * API call to get storage capacity info
 * @return A JSON with the storage used by this stack's storage account
 */
export async function getStorageCapacityApi(hostname, isAuthenticated, stack) {
    if (isAuthenticated) {
        try {
            const token = await getAccessToken();
            let url = `${hostname}/api/get_storage_capacity`;
            if (stack) url += `?stack=${stack}`;
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'content/type',
                    'Authorization': 'Bearer ' + token,
                    'x-custom-authorization': 'Bearer ' + token
                }
            });
            if (response.ok) {
                console.log('GET STORAGE CAPACITY API SUCCESS RESPONSE: ', response.status);
                let data = await response.json();
                console.log(data);
                return data;
            } else {
                console.log('GET STORAGE CAPACITY API ERROR RESPONSE: ', response.status);
                return response.status;
            }
        } catch (err) {
            console.error("[Fetch Error]:", err);
            return 504;
        }
    } else {
        return 401;
    }
}
